import {
  Error,
  Insertusersubdash,
  Getusersubdash,
  Insertusersubdashside,
  Getusersubside,
  Insertemailtry,
  UpdateQoute,
  Updatesqouteuserr,
  GetQoutsdashh,
  GetQoutssidee,
  Updateuserdashside
} from "../type";
import { InsertData, InsertDataWithImage } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
export const InsertusersubdashAction = (formData) => async (dispatch) => {
  try {
    const respons = await InsertDataWithImage(
      `/api/Dashboard/CreateUserSubscriptionFromDashbeard`,
      formData
    );
    dispatch({
      type: Insertusersubdash,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};
export const GetusersubdashAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(
      `/api/UserSubscription/GetUserSubscription`
    );
    dispatch({
      type: Getusersubdash,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};
export const GetQouteDashAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(
      `/api/Dashboard/GetQuotes`
    );
    dispatch({
      type: GetQoutsdashh,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};
export const GetQouteSideAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(
      `/api/UserSubscription/GetQuotes`
    );
    dispatch({
      type: GetQoutssidee,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};
export const InsertusersubdashsideAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(
      `/api/UserSubscription/CreateUserSubscriptionFromUserSide`,
      data
    );
    dispatch({
      type: Insertusersubdashside,
      payload: respons,
      loading: true,
    });  
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};
export const GetusersubsideAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(
      `/api/UserSubscription/GetMySubscriptions`
    );
    dispatch({
      type: Getusersubside,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};
export const UpdateUserdashAction = (data) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(
      `/api/Dashboard/UpdateUserSubscription`,
      data
    );
    dispatch({
      type: Updateuserdashside,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};
export const UpdateQuteuserAction = (data) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(
      `/api/UserSubscription/UpdateMyNotActiveSubscribtion`,
      data
    );
    dispatch({
      type: Updatesqouteuserr,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};

export const UpdateQuoteAction = (data) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(
      `/api/Dashboard/UpdateQuote`,
      data
    );
    dispatch({
      type: UpdateQoute,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};

export const InsertemailtryAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(
      `/api/UserSubscription/UserTyringToSubcribeAndWeSendEmail`,
      data
    );
    dispatch({
      type: Insertemailtry,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};
